<div class="atn-app-page">
  @if (meFeature.contexts.selectors.app.asSignal()?.supportsScenarios) {
    <atn-app-page-header />
  }

  <div class="atn-app-page__body">
    <atn-app-page-content />
  </div>
</div>
